import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { BRAND, PRIVACY_NOTICE } from "../config/content";
import { Logo } from "./Logo";
import { Reveal, FadeIn } from "./Reveal";
import { Marquee } from "./Marquee";

export const Intro = ({ onStart }) => {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: heroRef, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "16%"]);

  const payoffLines = ["Non tutto ciò", "che cerchi", "è cibo."];

  return (
    <div data-testid="intro-screen" className="bg-ivory">
      <header className="flex flex-col items-center pt-10 pb-2 px-6">
        <Logo />
      </header>

      <section ref={heroRef} className="px-6 pt-12 pb-16 max-w-md mx-auto">
        <h1 className="font-serif text-ink text-5xl leading-[1.02] tracking-tight">
          {payoffLines.map((line, i) => (
            <Reveal key={line} delay={0.15 + i * 0.14}>
              {line}
            </Reveal>
          ))}
        </h1>

        <FadeIn delay={0.75} className="mt-10">
          <div className="overflow-hidden">
            <motion.img
              src={BRAND.heroImage}
              alt="Albero dorato riflesso sull'acqua — Lacrime di Coccodrillo"
              data-testid="hero-image"
              style={{ y: imgY, objectPosition: "50% 42%" }}
              initial={{ scale: 1.1, opacity: 0 }}
              animate={{ scale: 1.04, opacity: 1 }}
              transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
              className="w-full aspect-[3/4] object-cover"
            />
          </div>
          <p className="mt-3 font-mono text-[10px] tracking-[0.25em] uppercase text-muted2">
            Capitolo I — L’esperienza olfattiva
          </p>
        </FadeIn>

        <FadeIn delay={0.9} className="mt-12">
          <p className="font-serif text-xl leading-relaxed text-ink whitespace-pre-line">
            {BRAND.introLead}
          </p>
          <p className="mt-6 text-base leading-relaxed text-muted2">{BRAND.introBody}</p>
        </FadeIn>

        <FadeIn delay={1.05} className="mt-12">
          <p className="text-xs leading-relaxed text-muted2 border-l border-gold pl-4">
            {PRIVACY_NOTICE}{" "}
            <Link to="/privacy" data-testid="privacy-link" className="underline underline-offset-4 text-ink">
              Leggi l’informativa completa
            </Link>
          </p>
          <button
            onClick={onStart}
            data-testid="start-button"
            className="group mt-8 w-full flex items-center justify-between border border-ink bg-ink text-ivory px-6 py-5 transition-colors duration-500 hover:bg-transparent hover:text-ink"
          >
            <span className="font-mono text-xs tracking-[0.35em]">{BRAND.startLabel}</span>
            <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" />
          </button>
        </FadeIn>
      </section>

      <Marquee />

      <footer className="border-t border-line px-6 py-10 text-center">
        <Logo small />
        <p className="mt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-muted2">
          {BRAND.payoff}
        </p>
      </footer>
    </div>
  );
};
